import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Text from 'components/common/Text'
import Button from 'components/common/Button'
import Link from 'components/common/Link'

import colors from 'utility/colors'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'

const ReadyToSignupBlock = ({
	link = '/signup',
	titleSize = 26,
	titleContainerStyle = {},
	containerStyle = {},
	buttonStyle = {},
	agent,
	buttonCopy = 'Lower My Taxes',
	subtitleStyle = {},
	hideTitle = false,
}) => {
	const { data: tenantProfile } = useTenantProfile()
	const primaryColor = tenantProfile?.theme?.primaryColor
	const tenantName = tenantProfile?.name

	return (
		<div style={{ width: '100%', ...containerStyle }}>
			{!hideTitle && (
				<Container>
					<Row style={{ marginTop: 90, ...titleContainerStyle }}>
						<Col xs='12'>
							<Text size={titleSize} bold align={'center'} color={colors.GRAY}>
								Stop overpaying your property taxes. Trust {tenantName} to help you keep more of
								your own money.
							</Text>
						</Col>
					</Row>
				</Container>
			)}
			<Row>
				<Col xs='12' style={{ textAlign: 'center' }}>
					<Link to={link}>
						<Button
							background={primaryColor}
							style={{
								maxWidth: 370,
								padding: 20,
								height: 'auto',
								fontSize: 20,
								fontWeight: 'bold',
								...buttonStyle,
							}}
						>
							{buttonCopy}
						</Button>
					</Link>
				</Col>
			</Row>
			<Row>
				<Col xs={{ span: 12 }}>
					<Text
						align={'center'}
						size={20}
						color={colors.LIGHT}
						bold
						style={{ marginTop: 30, ...subtitleStyle }}
					>
						2-Minute Signup | Low Fees | Safe & Secure
					</Text>
				</Col>
			</Row>
		</div>
	)
}

export default ReadyToSignupBlock
